import * as React from 'react'
import styled from 'styled-components'
import Spinner from '../../../components/ui/Spinner/Spinner'
import { useTermsAndConditions } from '../../../controllers/TnCAndPN'

const Description = styled.div`
  font-size: 0.875rem;

  table {
    border-collapse: collapse;
    margin: 1rem auto;
  }

  table td,
  table th {
    border: 1px solid;
    padding: 0.5em 1em;
  }
`
const SpinnerContainer = styled.div`
  height: 180px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const TncTitle = () => `Terms and Conditions`

export const TncDescription = () => {
  const { loading, tncContent, getTermsAndConditions } = useTermsAndConditions()
  const getContent = async () => {
    await getTermsAndConditions()
  }

  React.useEffect(() => {
    if (!tncContent) {
      getContent()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Description>
      {loading && !tncContent ? (
        <>
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer>
        </>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: tncContent }} />
      )}
    </Description>
  )
}

function TermsAndConditions(props) {
  return (
    <aside {...props}>
      <TncDescription />
    </aside>
  )
}

export default TermsAndConditions
